import { Component, OnDestroy, OnInit } from '@angular/core';
import { IBrandDetails } from 'src/app/core/domain/brand.model';
import { getBrandDetails, getGlobalSettings } from 'src/app/core/state/global';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, finalize, first, Observable, Subject, take, takeUntil, tap } from 'rxjs';
import { IProfileDetails } from 'src/app/core/domain/profile.model';
import { getProfileData } from 'src/app/core/state/profile';
import { ACCOUNT_TYPE } from 'src/app/core/domain';
import { ProfileService } from 'src/app/core/service/profile.service';
import { MembershipPlan } from 'src/app/core/domain/lastPlan.model';
import { PaymentsService } from 'src/app/core/service/payments.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-account-setting-page-top-nav',
  templateUrl: './account-setting-page-top-nav.component.html',
  styleUrls: ['./account-setting-page-top-nav.component.scss']
})
export class AccountSettingPageTopNavComponent implements OnInit, OnDestroy {

  brandDetails: Partial<IBrandDetails>;
  public getProfileData$: Observable<IProfileDetails>;
  profileData: IProfileDetails;
  private destroyed$: Subject<void> = new Subject();

  navLinks: any = [];
  private static cachedHasProformaInvoices: boolean | null = null;
  private get hasProformaInvoices(): boolean | null {
    return AccountSettingPageTopNavComponent.cachedHasProformaInvoices;
  }
  private set hasProformaInvoices(value: boolean | null) {
    AccountSettingPageTopNavComponent.cachedHasProformaInvoices = value;
  }
  private readonly proformaLink = {
    route: '/account/edit/proforma-invoices',
    title: 'Proforma Invoices',
    showMenu: true,
  };
  private readonly emailNotificationsLink = {
    route: '/account/edit/email/notification',
    title: 'Email Notifications',
    showMenu: true,
  };
  rightSideTabs: any = [
    {
      route: '/platform-updates',
      title: 'Platform updates',
      showMenu: true,
      featureKey: 'product_updates'
    }
  ];

  constructor(
    private readonly store: Store,
    private profileService: ProfileService,
    private paymentsService: PaymentsService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.store.pipe(select(getBrandDetails)).pipe(distinctUntilChanged()).subscribe((res) => {
      if (res) {
        this.brandDetails = res;



        this.getProfileData$ = this.store.pipe(select(getProfileData));

        this.getProfileData$.pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((res) => {
          if (res) {
            this.profileData = res;

            this.navLinks = [
              {
                route: '/account/edit/profile',
                title: 'Personal Information',
                showMenu: true,
              },

            ];
            

            // SAN-1478 — Notification Settings tab, shown only while the
            // tenant has the notification centre on.
            if(this.profileData.accountType !== ACCOUNT_TYPE.INDIVIDUAL && this.profileData.accountType !== ACCOUNT_TYPE.JOB_SEEKER) {
              this.navLinks.push({
                route: '/account/edit/notification',
                title: 'Notification Settings',
                showMenu: this.brandDetails?.features?.notification_centre_enabled === true,
              },)
            }

            if(this.profileData.accountType !== ACCOUNT_TYPE.JOB_SEEKER) {
              this.navLinks.push({
                route: '/account/edit/availability',
                title: 'Availability Hours',
                showMenu: this.brandDetails?.features?.online_meetings,
              },)
            }

            if(this.profileData.canAddMembers) {
              this.navLinks.push({
                route: '/account/edit/team',
                title: 'Account Access',
                showMenu: true,
              },)
            }

            if(this.profileData.accountType === ACCOUNT_TYPE.STARTUP) {
              this.navLinks.push({
                route: '/account/edit/digital-id-card',
                title: 'Recognized Id Card',
                /* Nav-only gate, same convention as every other flag-gated
                   entry here — the route itself has no flag guard, so a
                   disabled tenant hitting the URL directly still gets the
                   backend's own enabled:false response, handled inside
                   AccDigitalIdCardComponent, not blocked at the router. */
                showMenu: this.brandDetails?.features?.startup_recognition_enabled,
              },)
            }
            const membershipactive = localStorage.getItem('membershipactive')
          if(this.brandDetails.features?.membership_enabled && membershipactive =='true'){
             const approvalStatus = localStorage.getItem('profile-approval-status');
             const storedData = localStorage.getItem('lastmembership');
             const lastPlanData: MembershipPlan | null = storedData ? JSON.parse(storedData) : null;

             if( (this.brandDetails.features?.membership_visibility_type== 'approved' && (approvalStatus=='approved' || lastPlanData)) || (this.brandDetails.features?.membership_visibility_type== 'anyone') || (this.brandDetails.features?.membership_visibility_type == 'manual' && lastPlanData)){
            this.navLinks.push(
              {
                route: '/account/edit/membership',
                title: this.brandDetails.features.membership_label_text || "Membership",
                showMenu: true,
              })
            }
          }
            //   this.navLinks.push(
            //     {
            //       route: '/account/edit/orders',
            //       title: 'Orders',
            //       showMenu: true,
            //     })
  

            // if(this.brandDetails?.features?.certificates && this.profileData.accountType === ACCOUNT_TYPE.STARTUP) {
            //   this.profileService.getCertificates().subscribe((res) => {
            //     console.log('res', res)
            //     if (res) {
            //       if(!this.navLinks.find((e)=>e.title === 'Certificate')) {
            //         if((res.data || []).length) {
            //           this.navLinks.push({
            //             route: '/account/edit/certificates',
            //             title: 'Certificate',
            //             showMenu: true,
            //           },)
            //         }
            //       }
            //     }
            //   })
            // }

          }

           if (this.hasProformaInvoices) {
             this.navLinks.push(this.proformaLink);
           }
           this.navLinks.push(this.emailNotificationsLink);

           const profileUUID = this.profileData?.profileUUID;
           if (this.profileData?.accountType && profileUUID) {
             this.paymentsService
               .getProformaInvoicesByProfile(this.profileData.accountType, profileUUID)
               .pipe(take(1), takeUntil(this.destroyed$))
               .subscribe({
                 next: (res: any[]) => {
                   const hasInvoices = (res || []).length > 0;
                   const presenceChanged = this.hasProformaInvoices !== hasInvoices;
                   this.hasProformaInvoices = hasInvoices;
                   if (!presenceChanged) return;
                   if (hasInvoices) {
                     if (!this.navLinks.find((e: any) => e.route === this.proformaLink.route)) {
                       const emailIdx = this.navLinks.findIndex((e: any) => e.route === this.emailNotificationsLink.route);
                       const insertAt = emailIdx >= 0 ? emailIdx : this.navLinks.length;
                       this.navLinks.splice(insertAt, 0, this.proformaLink);
                     }
                   } else {
                     const idx = this.navLinks.findIndex((e: any) => e.route === this.proformaLink.route);
                     if (idx >= 0) this.navLinks.splice(idx, 1);
                     if (this.router.url.includes(this.proformaLink.route)) {
                       const lastLink = [...this.navLinks].reverse().find((l: any) => l?.showMenu && l?.route);
                       if (lastLink?.route) this.router.navigateByUrl(lastLink.route);
                     }
                   }
                 },
                 error: () => {},
               });
           }
        })
      }
    })
  }


  trackByRoute(_: number, link: any): string {
    return link?.route || '';
  }

  ngOnDestroy(): void {
    this.destroyed$.complete()
  }

}
